import { scroller } from 'react-scroll';

import { getTitleId } from 'components/Pages/Admin/Page/Landing/utils';
import { LANDING_PAGES_CONTAINER_ID } from 'components/shared/LandingPage/components/Grid';
import { useScrollOffset } from 'hooks/useScrollOffset';
import { IPage } from 'utils/itineraryDetails/types';
import { getCurrentDatePage } from 'utils/proposals';

type Props = {
  pages?: IPage[];
  landingTheme?: string;
};

export const useScrollToCurrentDatePage = ({ pages = [], landingTheme }: Props) => {
  const { clickOffset } = useScrollOffset({ landingTheme, isItinerariesItem: true });

  const handleScrollToCurrentDatePage = () => {
    const targetPage = getCurrentDatePage(pages);
    const targetPageIndex = pages.findIndex((page) => page?.id === targetPage?.id);

    if (!targetPage) return;
    if (targetPageIndex === -1) return;

    const targetLink = getTitleId(targetPage.headline, targetPageIndex);
    if (!targetLink) return;

    setTimeout(() => {
      scroller.scrollTo(targetLink, {
        containerId: LANDING_PAGES_CONTAINER_ID,
        smooth: true,
        duration: 200,
        offset: clickOffset(targetPageIndex === 0),
      });
    });
  };

  return { handleScrollToCurrentDatePage };
};
